import DefaultModal from "components/Common/Modal/DefaultModal";
import ModalButton from "components/Common/Modal/ModalButton";
import React from "react";
import { useNavigate } from "react-router-dom";

const SignupApproveModal = ({ modalClose }: { modalClose: () => void }) => {
  const navigate = useNavigate();

  return (
    <DefaultModal
      title="회원가입이 완료되었습니다"
      content={`회원가입이 완료되었습니다.\nIBS 검사를 통해 병원의 현황을 파악해보세요.`}
      handlModalClose={modalClose}
      state="positive"
      button={
        <ModalButton
          buttonType="two"
          confirmButtonText="IBS 검사하기"
          handleConfirm={() => {
            navigate("/mypage/ibs");
            modalClose();
          }}
          handleCancel={modalClose}
        />
      }
    />
  );
};

export default SignupApproveModal;
